var map = {
	"./backup/en/messages": [
		"./src/locales/backup/en/messages.js",
		"src_locales_backup_en_messages_js"
	],
	"./backup/ms/messages": [
		"./src/locales/backup/ms/messages.js",
		"src_locales_backup_ms_messages_js"
	],
	"./backup/zh/messages": [
		"./src/locales/backup/zh/messages.js",
		"src_locales_backup_zh_messages_js"
	],
	"./en/messages": [
		"./src/locales/en/messages.js",
		"src_locales_en_messages_js"
	],
	"./ms/messages": [
		"./src/locales/ms/messages.js",
		"src_locales_ms_messages_js"
	],
	"./zh/messages": [
		"./src/locales/zh/messages.js",
		"src_locales_zh_messages_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/locales lazy recursive ^\\.\\/.*\\/messages$";
module.exports = webpackAsyncContext;